// extracted by mini-css-extract-plugin
export default {"generalWallboardCSI":"style_generalWallboardCSI__SeTBn","filterWrapper":"style_filterWrapper__RjhKV","captionWrapper":"style_captionWrapper__lXlzO"};